import "./TopicDropdown.css"


const topics  = [
    "Discrete Math", 
    "Start Coding", 
    "Linear Algebra",
    "Data Structures",
    "Operating Systems"
]

export default function TopicDropdown({topic_checkboxes, set_topic_checkboxes}){
    const topicsList = topics.map(topic =>
        <li
            onClick={() => {
                if(!topic_checkboxes.includes(topic)) set_topic_checkboxes([...topic_checkboxes, topic])
                else set_topic_checkboxes(topic_checkboxes.filter(tpk => tpk !== topic))
            }}
        > 
            {topic} 
            <label className="modalities-checkbox"
                
            >
                <input type="checkbox" className="input-checkbox"
                    checked={topic_checkboxes.includes(topic)}
                />
            </label>
        </li>)
    
    return (
        <div className="topics-container">
            <ul className="topics-list">
                {topicsList}
            </ul>
        </div>
    );
}